import type { QuoteComponent } from "../../types";

/**
 * Editorial pulled quote: accent-yellow left bar, large quote text, optional
 * author/role attribution. Renders nothing without quote text.
 */
export function QuoteRenderer({ component }: { component: QuoteComponent }) {
  const content = component.content ?? ({} as QuoteComponent["content"]);
  const quote = content.quote?.trim();
  if (!quote) return null;

  const author = content.author?.trim();
  const role = content.role?.trim();
  return (
    <section data-quote>
      <blockquote className="border-l-4 border-[#FFA401] pl-5 md:pl-6">
        <p
          className="text-lg md:text-xl leading-relaxed text-[#0F2849]"
          style={{ fontFamily: "var(--font-aleo)" }}
        >
          « {quote} »
        </p>
        {author || role ? (
          <footer className="mt-3 text-sm md:text-base text-[#0F2849]/70">
            {author ? <span className="font-semibold text-[#005CA9]">{author}</span> : null}
            {author && role ? <span aria-hidden="true"> — </span> : null}
            {role ? <span>{role}</span> : null}
          </footer>
        ) : null}
      </blockquote>
    </section>
  );
}
